import { render, staticRenderFns } from "./InfoSection.vue?vue&type=template&id=29adb7ea&scoped=true&lang=pug"
import script from "./InfoSection.vue?vue&type=script&lang=js"
export * from "./InfoSection.vue?vue&type=script&lang=js"
import style0 from "./InfoSection.vue?vue&type=style&index=0&id=29adb7ea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29adb7ea",
  null
  
)

export default component.exports